import React, { ReactElement } from 'react';

import { PermissionComponentProps } from "./PermissionComponent.types";
import { usePermission } from '../../../hooks';

export const PermissionComponent: React.FC<PermissionComponentProps> = ({children, permission}): ReactElement | null => {

  const permitted = usePermission(permission);

  // GET role, check permission
  if (permitted) {
    return children as React.ReactElement;
  }

  return null;

}
